export { storage as default } from '../contexts/FirebaseContext';